// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.styles_formContainer__fVpFc {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
}

.styles_button__6J2v\\+ {
  position: relative;
  text-align: right;
  background-color: #fafafa !important;
}

.styles_buttonStyle__MfZEb {
  background-color: inherit !important;
}

.styles_button__6J2v\\+:hover {
  cursor: pointer;
}

.styles_srtWrapper__Zor7M {
  width: 100% !important;
}

.styles_srtInputStyle__KUMmG {
  width: 0px !important;
}

.styles_button__6J2v\\+::after {
  position: absolute;
  left: 5px;
  top: 4px;
  content: "❬";
  transform: rotate(90deg);
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.54);
}

.styles_button__6J2v\\+.styles_expanded__kFjs7::after {
  content: "❭";
}

.styles_inputStyle__z2ms6 {
  width: 48%;
  margin-left: 2%;
}

.styles_inputStyleFull__Va1Kk {
  width: 98%;
  margin-left: 2%;
}

.styles_inputWrapper__1fEsa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  width: 100% !important;
  height: 44px;
}

.styles_inputStyleFullWrapper__\\+gJp0 {
  width: 100%;
  height: auto;
  aspect-ratio: 8;
}

.styles_switchContainer__igtPI {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 48%;
  height: auto;
  margin-left: 2%;
  margin-top: 8px;
  margin-bottom: 8px;
}

.styles_switchTitle__1fi0C {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
}

.styles_switchDescription__VR3XV {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  color: #484848;
}

.styles_chooseButton__01ftO {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  color: #d8000d;
}

.styles_seenBy__-mF3W {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  color: #646464;
}

.styles_change__Dm2PI {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  text-align: right;
  color: #d8000d;
  margin: 0 12px;
}

.styles_setting__d7Upa {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  color: #d8000d;
  margin-bottom: 14px;
}

.styles_helpFooter__99uYU {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  text-align: right;
  color: #d8000d;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #e9e9e9;
  padding-top: 11px;
}

.styles_searchContainer__M2TEB {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 90%;
  /* Elevation */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding-bottom: 5px;
  padding-left: 9px;
  padding-right: 9px;
  z-index: 1000;
}

.styles_playlistContainer__3P-wL {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  top: 90%;
  /* Elevation */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding-bottom: 5px;
  padding-left: 9px;
  padding-right: 9px;
  z-index: 1000;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */
  color: #535353;
}

.styles_viewContainer__xSSFB {
  position: absolute;
  width: 356px;
  height: auto;
  right: 100%;
  top: -100px;
  /* Elevation */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  padding: 10px;
  z-index: 1000;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */
  color: #535353;
}

.styles_playlistText__9Y9yE {
  margin-right: 11px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  text-align: right;
  color: #d8000d;
  cursor: pointer;
}

.styles_writeTag__Q-xxh {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  /* Elevation */
  margin-bottom: 5px;
}

.styles_addTag__Nc\\+Xv {
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #d8000d;
  border: 1px solid #d8000d;
  width: 20%;
  margin-right: 2%;
  border-radius: 8px;
  height: 44px;
  margin-top: 5px;
  cursor: pointer;
}

.styles_addTag__Nc\\+Xv span {
  width: auto;
  margin: 0 auto;
}

.styles_singleTag__PTRXz {
  /* Gray / gray-5 */
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 0px 5px;
  margin: 2px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #262626;
  white-space: nowrap;
}

.styles_srtTitle__IaJYz {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  color: #535353;
  width: 100%;
}

.styles_lds_ring__mQV\\+C {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
  margin-right: 20px;
}

.styles_lds_ring__mQV\\+C div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 8px;
  border: 1px solid #d8000d;
  border-radius: 50%;
  animation: styles_lds_ring__mQV\\+C 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #d8000d transparent transparent transparent;
}

.styles_lds_ring__mQV\\+C div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ring__mQV\\+C div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ring__mQV\\+C div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ring__mQV\\+C {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.styles_chooseText__mFSKb {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 35px;
  color: #969696;
}

.styles_tagBoxStyle__aYKJQ {
  max-height: 200px;
  overflow-y: auto;
  scrollbar-color: #e3e3e3 transparent;
  scrollbar-width: 5px;
}

.styles_tagBoxStyle__aYKJQ::-webkit-scrollbar {
  background: transparent;
  width: 5px;
}

.styles_tagBoxStyle__aYKJQ::-webkit-scrollbar-thumb {
  background-color: #e3e3e3;
  border-radius: 100px;
  height: 5px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/UploadVideoMoreInfo/styles.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAEF;;AACA;EACE,kBAAA;EACA,iBAAA;EAEA,oCAAA;AACF;;AACA;EACE,oCAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AAAA;EACE,sBAAA;AAGF;;AADA;EACE,qBAAA;AAIF;;AAFA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,0BAAA;AAKF;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,UAAA;EACA,eAAA;AAKF;;AAFA;EACE,UAAA;EACA,eAAA;AAKF;;AAFA;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EAEA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AAGF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAGF;;AAAA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EAEA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,iBAAA;EAEA,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,iBAAA;EAEA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EAEA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wHAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EAEA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wHAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,cAAA;AAVF;;AAaA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EAEA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wHAAA;EAEA,kBAAA;EACA,aAAA;EAIA,aAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,cAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,iBAAA;EAEA,cAAA;EACA,eAAA;AApBF;;AAuBA;EACE,sBAAA;EAEA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EAGA,cAAA;EAIA,kBAAA;AA1BF;;AA+BA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;EAGA,kBAAA;EAEA,YAAA;EACA,eAAA;EACA,eAAA;AA/BF;;AAkCA;EACE,WAAA;EACA,cAAA;AA/BF;;AAkCA;EAEE,kBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,cAAA;EACA,WAAA;AAlCF;;AAqCA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAlCF;;AAqCA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,6EAAA;EACA,yDAAA;AAlCF;;AAqCA;EACE,uBAAA;AAlCF;;AAqCA;EACE,sBAAA;AAlCF;;AAqCA;EACE,uBAAA;AAlCF;;AAqCA;EACE;IACE,uBAAA;EAlCF;EAqCA;IACE,yBAAA;EAnCF;AACF;AAsCA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApCF;;AAuCA;EACE,iBAAA;EACA,gBAAA;EACA,oCAAA;EACA,oBAAA;AApCF;;AAuCA;EAEE,uBAAA;EACA,UAAA;AArCF;;AAwCA;EACE,yBAAA;EACA,oBAAA;EACA,WAAA;AArCF","sourcesContent":[".formContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  width: 100%;\n  height: auto;\n}\n\n.button {\n  position: relative;\n  text-align: right;\n\n  background-color: #fafafa !important;\n}\n.buttonStyle{\n  background-color: inherit !important;\n}\n\n.button:hover {\n  cursor: pointer;\n}\n.srtWrapper{\n  width:100% !important;\n}\n.srtInputStyle{\n  width:0px !important;\n}\n.button::after {\n  position: absolute;\n  left: 5px;\n  top: 4px;\n  content: '\\276C';\n  transform: rotate(90deg);\n  margin-top: 2px;\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.button.expanded::after {\n  content: '\\276D';\n}\n\n.inputStyle {\n  width: 48%;\n  margin-left: 2%;\n}\n\n.inputStyleFull {\n  width: 98%;\n  margin-left: 2%;\n}\n\n.inputWrapper {\n  // width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  // background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  width: 100% !important;\n  height: 44px;\n}\n\n.inputStyleFullWrapper {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 8;\n}\n\n.switchContainer {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 48%;\n  height: auto;\n  margin-left: 2%;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.switchTitle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  // margin-bottom: 13px;\n}\n\n.switchDescription {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n\n  text-align: right;\n\n  color: #484848;\n}\n\n.chooseButton {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n  color: #d8000d;\n}\n\n.seenBy {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: right;\n  color: #646464;\n}\n\n.change {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n\n  text-align: right;\n\n  color: #d8000d;\n  margin: 0 12px;\n}\n\n.setting {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: right;\n  color: #d8000d;\n  margin-bottom: 14px;\n}\n\n.helpFooter {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n\n  text-align: right;\n\n  color: #d8000d;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  border-top: 1px solid #e9e9e9;\n  padding-top: 11px;\n}\n\n.searchContainer {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  left: 0;\n  top: 90%;\n  // background: #FFFFFF;\n  /* Elevation */\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),\n    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  padding-bottom: 5px;\n  padding-left: 9px;\n  padding-right: 9px;\n  z-index: 1000;\n}\n\n.playlistContainer {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  left: 0;\n  top: 90%;\n  // background: #FFFFFF;\n  /* Elevation */\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),\n    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  padding-bottom: 5px;\n  padding-left: 9px;\n  padding-right: 9px;\n  z-index: 1000;\n  // border-bottom: 1px solid #E9E9E9;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  /* identical to box height, or 167% */\n\n  color: #535353;\n}\n\n.viewContainer {\n  position: absolute;\n  width: 356px;\n  height: auto;\n  right: 100%;\n  // top: -200px; -------- use later\n  top: -100px;\n  // background: #FFFFFF;\n  /* Elevation */\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),\n    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  padding: 10px;\n  // padding-bottom: 5px;\n  // padding-left: 9px;\n  // padding-right: 9px;\n  z-index: 1000;\n  // border-bottom: 1px solid #E9E9E9;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  /* identical to box height, or 167% */\n\n  color: #535353;\n}\n\n.playlistText {\n  margin-right: 11px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n\n  text-align: right;\n\n  color: #d8000d;\n  cursor: pointer;\n}\n\n.writeTag {\n  box-sizing: border-box;\n\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  // background-color: #ffffff;\n  // background: #FFFFFF;\n  /* Elevation */\n\n  // box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);\n  // border-radius: 2px;\n  margin-bottom: 5px;\n  // padding-left: 9px;\n  // padding-right: 9px;\n}\n\n.addTag {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 19px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #d8000d;\n  border: 1px solid #d8000d;\n  width: 20%;\n  margin-right: 2%;\n  // height: auto;\n  // aspect-ratio: 2;\n  border-radius: 8px;\n  // background-color: #ffffff;\n  height: 44px;\n  margin-top: 5px;\n  cursor: pointer;\n}\n\n.addTag span {\n  width: auto;\n  margin: 0 auto;\n}\n\n.singleTag {\n  // background: #DFDFDF;\n  /* Gray / gray-5 */\n\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  padding: 0px 5px;\n  margin: 2px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #262626;\n  white-space: nowrap;\n}\n\n.srtTitle {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  /* identical to box height, or 143% */\n\n  color: #535353;\n  width: 100%;\n}\n\n.lds_ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-bottom: 10px;\n  margin-right: 20px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 8px;\n  border: 1px solid #d8000d;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #d8000d transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.chooseText {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 35px;\n  color: #969696;\n}\n\n.tagBoxStyle {\n  max-height: 200px;\n  overflow-y: auto;\n  scrollbar-color: #e3e3e3 transparent;\n  scrollbar-width: 5px;\n}\n\n.tagBoxStyle::-webkit-scrollbar {\n  // display: none !important;\n  background: transparent;\n  width: 5px;\n}\n\n.tagBoxStyle::-webkit-scrollbar-thumb {\n  background-color: #e3e3e3;\n  border-radius: 100px;\n  height: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `styles_formContainer__fVpFc`,
	"button": `styles_button__6J2v+`,
	"buttonStyle": `styles_buttonStyle__MfZEb`,
	"srtWrapper": `styles_srtWrapper__Zor7M`,
	"srtInputStyle": `styles_srtInputStyle__KUMmG`,
	"expanded": `styles_expanded__kFjs7`,
	"inputStyle": `styles_inputStyle__z2ms6`,
	"inputStyleFull": `styles_inputStyleFull__Va1Kk`,
	"inputWrapper": `styles_inputWrapper__1fEsa`,
	"inputStyleFullWrapper": `styles_inputStyleFullWrapper__+gJp0`,
	"switchContainer": `styles_switchContainer__igtPI`,
	"switchTitle": `styles_switchTitle__1fi0C`,
	"switchDescription": `styles_switchDescription__VR3XV`,
	"chooseButton": `styles_chooseButton__01ftO`,
	"seenBy": `styles_seenBy__-mF3W`,
	"change": `styles_change__Dm2PI`,
	"setting": `styles_setting__d7Upa`,
	"helpFooter": `styles_helpFooter__99uYU`,
	"searchContainer": `styles_searchContainer__M2TEB`,
	"playlistContainer": `styles_playlistContainer__3P-wL`,
	"viewContainer": `styles_viewContainer__xSSFB`,
	"playlistText": `styles_playlistText__9Y9yE`,
	"writeTag": `styles_writeTag__Q-xxh`,
	"addTag": `styles_addTag__Nc+Xv`,
	"singleTag": `styles_singleTag__PTRXz`,
	"srtTitle": `styles_srtTitle__IaJYz`,
	"lds_ring": `styles_lds_ring__mQV+C`,
	"chooseText": `styles_chooseText__mFSKb`,
	"tagBoxStyle": `styles_tagBoxStyle__aYKJQ`
};
export default ___CSS_LOADER_EXPORT___;
